import Index from "../index";
import {GetStaticPaths, GetStaticProps} from 'next';
import {apiRequest} from "../../util/util";

// Define paths that should be pre-rendered
export const getStaticPaths: GetStaticPaths = async () => {
    const payload = {
        target: 'list-public-stories',
        'theme': 'erotica',
        'tags': [],
        'offset': 0,
        "blockSize": 10000,
        'returnSections': false,
    }
    debugger
    const resp = fetch('https://mytales.io/api/ml',
        {
            method: 'POST',
            body: JSON.stringify(payload),
        }
    )
    const res = await resp;
    const res2 = await res.json()
    const stories = res2.data.stories;

    console.log('static paths...')
    const paths = stories.map((story: any) => ({
        params: {
            storyId: story.storyId,
        }
    }))
    console.log('story ' +
        'paths are', paths)
    return {
        paths: paths,
        fallback: true, // Enable ISR for unspecified paths
    };
};
// Get static props for each page
export const getStaticProps: GetStaticProps = async (context) => {
    const storyId = context.params?.storyId;
    return {
        props: {
            storyId,
        },
        revalidate: 1, // Revalidate every 1 second (adjust as needed)
    };
};

export default Index;
